import React from 'react';
import { Button, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import JapaneseDatePicker from '../../components/JapaneseDatePicker';
import moment from 'moment';
import { MONTHS } from '../../../utils/constants';

const MonthlyHeader = (props) => {

    const MONTH_RANGE = 3;

    return (
        <Col>
            <Col className="mobile-section-header">
                <span>
                    <div className="flex">
                        <Button
                            className="button-toggle"
                            onClick={props.setPrevDate}
                            disabled={moment().subtract(MONTH_RANGE, MONTHS).month() === moment(props.filterDate).month()}
                        >
                            <FontAwesomeIcon icon={"caret-left"} />
                        </Button>

                        {' '}

                        <JapaneseDatePicker
                            name="filterDate"
                            noIcon={true}
                            mobile={true}
                            disableType={true}
                            disabled={true}
                            selected={props.filterDate}
                            dateFormat={"MM月分"}
                            onChangeRaw={props.handleDateChangeRaw}
                            className="clear-hidden"
                        />

                        {''}

                        <Button
                            className="button-toggle"
                            onClick={props.setNextDate}
                            disabled={moment().add(MONTH_RANGE, MONTHS).month() === moment(props.filterDate).month()}
                        >
                            <FontAwesomeIcon icon={"caret-right"} />
                        </Button>
                    </div>
                </span>
                <Button className="mobile-header-button" disabled={props.disableSubmit} onClick={props.handleSubmit}>確定</Button>
            </Col>
        </Col>
    );
};

export default MonthlyHeader;